import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { EnrollApi } from 'api';
import { IEvent } from 'types';
import { USER_KEY } from './keys';

function useGetInfiniteByUser(userId: number, size = 30) {
  return useAuthInfiniteList<{ event: IEvent }>(
    [...getQueryKeys([USER_KEY]).lists(), 'infinite', { userId, size }],
    (page) => EnrollApi.getAllByUserId({ userId, page, size }),
    !!userId,
  );
}

export default useGetInfiniteByUser;
